import React from 'react';
import { useLocation } from 'react-router-dom';
import './WhatsAppWidget.css';

/**
 * WhatsAppWidget
 * Props:
 *  - phone: string (with country code) e.g. +212600000000 (default placeholder)
 *  - message: default message sent in the chat
 *
 * Usage: change the phone prop to your WhatsApp number.
 */
const WhatsAppWidget = ({ phone = '+212600000000', message }) => {
  const { pathname } = useLocation();

  // derive a contextual message based on the current URL if message wasn't explicitly provided
  const computedMessage = message || (() => {
    const p = (pathname || '').toLowerCase();
    if (p.includes('camp-detail')) return 'hey let me help you with your camps booking';
    if (p.includes('package-detail')) return 'hey let me help you with your packages booking';
    if (p.includes('accomodation-detail') || p.includes('accommodation-detail')) return 'hey let me help you with your accomodation booking';
    if (p.includes('prices') || p.includes('offers')) return 'hey let me help you with your bookings';
    return "Hello! I'm interested in your services.";
  })();

  // remove any non-digit characters from phone number for wa.me format
  const phoneDigits = (phone || '').replace(/\D/g, '');
  const encoded = encodeURIComponent(computedMessage || '');
  const href = `https://wa.me/${phoneDigits}${encoded ? `?text=${encoded}` : ''}`;

  return (
    <a
      href={href}
      className="whatsapp-widget"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contact us on WhatsApp"
      title="Chat with us on WhatsApp"
    >
      <div className="whatsapp-container">
        <div className="whatsapp-message" role="status">{computedMessage}</div>
        <div className="whatsapp-button">
          {/* WhatsApp SVG icon */}
          <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path fill="currentColor" d="M20.52 3.48A11.86 11.86 0 0 0 12 .5C6.21.5 1.46 5.24 1.46 11c0 1.94.52 3.82 1.5 5.47L.5 23.5l6.32-2.04c1.57.86 3.32 1.32 5.18 1.32 5.79 0 10.54-4.74 10.54-10.5 0-2.82-1.11-5.46-3.02-7.8zM12 21.5c-1.6 0-3.17-.43-4.55-1.24l-.33-.19-3.76 1.22 1.22-3.67-.2-.36A8.57 8.57 0 0 1 3.5 11c0-4.72 3.85-8.56 8.5-8.56 2.27 0 4.4.88 6 2.48 1.6 1.6 2.48 3.74 2.48 6 0 4.66-3.84 8.56-8.5 8.56z"/>
            <path fill="#fff" d="M17.52 14.1c-.32-.16-1.88-.92-2.17-1.02-.29-.1-.5-.16-.71.16-.2.32-.8 1.02-.98 1.23-.18.2-.36.23-.68.08-1.86-.9-3.08-3.04-3.08-5.5 0-1.45.52-2.2.9-2.84.22-.38-.02-.6-.16-.76-.16-.17-.71-1.72-.98-2.37-.25-.62-.5-.54-.71-.55-.18 0-.38-.02-.58-.02-.2 0-.52.07-.8.36-.28.29-1.06 1.04-1.06 2.53 0 1.5 1.08 2.96 1.23 3.17.16.22 2.12 3.26 5.15 4.44.72.31 1.28.5 1.72.64.72.22 1.38.19 1.9.12.58-.08 1.88-.77 2.14-1.51.26-.74.26-1.37.18-1.51-.08-.15-.29-.24-.6-.4z"/>
          </svg>
        </div>
      </div>
    </a>
  );
};

export default WhatsAppWidget;
